/*
 * @Description: 客户结算单
 * @Author: 杨志航
 * @Date: 2026-06-18 10:20:30
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  Spin,
  DatePicker,
  Drawer,
} from 'antd'
import Auth from '@/components/AuthMiddleware'
import { allTrim, filterParams, cryptoParamsIntoUrl, getMethodExport } from '@/utils'
import { Link } from 'react-router-dom'
import CustomerConfirm from '../module/CustomerConfirm'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const dateFormat = 'YYYY-MM'
const approvalList = [
  { id: 1, name: '审批中'},
  { id: 2, name: '审批通过'},
  { id: 3, name: '审批失败'},
]
const emailList = [
  { id: 1, name: '邮件未发送'},
  { id: 2, name: '邮件已发送'},
]
const confirmList = [
  { id: 1, name: '邮件确认'},
  { id: 2, name: '盖章确认'},
  { id: 3, name: '邮件+盖章确认'},
]
const repaymentList = [
  { id: 1, name: '未收款'},
  { id: 2, name: '部分收款'},
  { id: 3, name: '已收款'},
  { id: 4, name: '收款中'},
]
const invoiceList = [
  { id: 1, name: '未开票'},
  { id: 2, name: '部分开票'},
  { id: 3, name: '已开票'},
]
const settlementMethodList = [
  { id: 1, name: '消耗结算'},
  { id: 2, name: '充值结算'},
]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const Main = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [authList, setAuthList] = useState([])
  const [companyList, setCompanyList] = useState([])
  const [isopen, setIsopen] = useState(false)
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [confirmData, setConfirmData] = useState({})

  useEffect(() => {
    resetParams()
    getSearchData()
    getPageAuth()
    getList()
  }, [])

  const getSearchData = () => {
    Promise.all([
      api.getSelectCompanyList({ limit: global.paramsLimit }),
    ]).then(data => {
      setCompanyList(data[0].list)
    })
  }

  //按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then(list => {
      setAuthList(list)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getSettlementOrderList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.settlementMonth) {
          vals.settlementMonth = vals.settlementMonth.format(dateFormat)
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 导出
  const exportFile = () => {
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    params.export = 1
    setSpinLoading(true)
    getMethodExport('/fortune/SettlementOrder/getList', params).then(() => {
      setSpinLoading(false)
    }).catch(() => setSpinLoading(false))
  }

  // 弹出日历和关闭日历的回调
  const handleOpenChange = status => setIsopen(status)
  // 拿到value并进行处理
  const handlePanelChange = value => {
    setIsopen(false)
    setFieldsValue({ settlementMonth: value })
  }

  const handleConfirm = record => { 
    setConfirmData(record)
    setConfirmVisible(true)
  }

  const handleInvoice = record => {
    const { id, invoiceAmount, clientType, clientId, companyId } = record
    let params = {
      settlementOrderId: id,
      companyId,
      invoiceAmount,
    }
    if (clientType == 0) {
      params.oaId = clientId
    } else {
      params.qId = clientId
    }
    history.push('/protocol/invoice/apply', params)
  }

  return <>
    <Spin spinning={spinLoading}>
      <div className="search-doc-wrap">
        <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
          <div className="form-box">
            <FormItem label="结算单编号">
              {getFieldDecorator('settlementNo')(<Input placeholder="请输入结算单编号" />)}
            </FormItem>
            <FormItem label="对方主体">
              {getFieldDecorator('clientName')(<Input placeholder="请输入对方主体" />)}
            </FormItem>
            <FormItem label="我方主体">
              {getFieldDecorator('companyId')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="结算单月份">
              {getFieldDecorator('settlementMonth')(<DatePicker 
                open={isopen} 
                mode="month"
                placeholder="请选择"
                format={dateFormat}
                onOpenChange={handleOpenChange} 
                onPanelChange={handlePanelChange}
                style={{ width: '100%'}}
              />)}
            </FormItem>
            <FormItem label="邮件状态">
              {getFieldDecorator('emailStatus')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  emailList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="确认状态">
              {getFieldDecorator('confirmStatus')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  confirmList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="收款状态">
              {getFieldDecorator('repaymentStatus')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  repaymentList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="开票状态">
              {getFieldDecorator('invoiceStatus')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  invoiceList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="审批状态">
              {getFieldDecorator('approvalStatus')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  approvalList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="业务审批人">
              {getFieldDecorator('businessApprover')(<Input placeholder="请输入业务审批人" />)}
            </FormItem>
            <FormItem label="内控审批人">
              {getFieldDecorator('internalApprover')(<Input placeholder="请输入内控审批人" />)}
            </FormItem>
            <FormItem label="客户邮箱">
              {getFieldDecorator('customerEmail')(<Input placeholder="请输入客户邮箱" />)}
            </FormItem>
            <FormItem label="结算方式">
              {getFieldDecorator('settlementMethod')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  settlementMethodList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="回款主体">
              {getFieldDecorator('repaymentEntity')(<Input placeholder="请输入回款主体" />)}
            </FormItem>
            <FormItem label="订单编号">
              {getFieldDecorator('orderNumber')(<Input placeholder="请输入订单编号" />)}
            </FormItem>
            <FormItem label="厂商ID">
              {getFieldDecorator('vendorId')(<Input placeholder="请输入厂商ID" />)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <Button type="primary" htmlType="submit">查询</Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div>
        <div className="add-wrap">
          <Auth auths={authList} code="settlement-method-setting">
            <Button type="primary" onClick={() => history.push('/billManage/customerBill/approvalConfig')}>结算单审批配置</Button>
          </Auth>
          <Auth auths={authList} code="export">
            <Button type="primary" onClick={exportFile} style={{ marginLeft: 15 }}>导出</Button>
          </Auth>
        </div>
        <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
        <Table
          size="small"
          dataSource={list}
          rowKey={(record, index) => index}
          loading={loading}
          pagination={{
            pageSize,
            total: count,
            current: currentPage,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
          scroll={{ x: 'max-content' }}
        >
          <Column 
            title="序号" 
            dataIndex="id"
            fixed="left"
            render={(text, record, index) => count - ((currentPage - 1) * pageSize + index)} 
          />
          <Column 
            title="结算单编号" 
            dataIndex="settlementNo" 
            fixed="left"
            render={(text, record) => (
              <Link 
                to={cryptoParamsIntoUrl('/billManage/customerBill/detail', { id: record.id })}
                target="_blank"
              >
                {text}
              </Link>
            )}
          />
          <Column title="结算单月份" dataIndex="settlementMonth" />
          <Column title="对方主体" dataIndex="clientName" />
          <Column title="我方主体" dataIndex="companyName" />
          <Column title="结算方式" dataIndex="settlementMethodName" />
          <Column title="系统充值" dataIndex="systemRecharge" />     
          <Column title="本月消耗" dataIndex="monthConsume" />
          <Column title="应付金额" dataIndex="payable" />
          <Column title="已付金额" dataIndex="totalPaid" />
          <Column title="已还款" dataIndex="totalRepaymentAmount" />
          <Column 
            title="客户邮箱" 
            dataIndex="customerEmails" 
            render={(text, record) => (
              <>
                {text.map((item, index) => (
                  <div key={index}>{item}</div>
                ))}
              </>
            )}
          />
          <Column title="回款主体" dataIndex="repaymentSubject" />     
          <Column 
            title="审批状态" 
            dataIndex="approvalStatusName" 
            render={(text, record) => (
              <Link 
                to={cryptoParamsIntoUrl('/billManage/customerBill/detail', { id: record.id })}
                target="_blank"
              >
                {text}
              </Link>
            )}
          />
          <Column title="邮件状态" dataIndex="emailStatusName" />
          <Column title="确认状态" dataIndex="confirmStatusName" />
          <Column title="收款状态" dataIndex="repaymentStatusName" />
          <Column title="开票状态" dataIndex="invoiceStatusName" />
          <Column 
            title="业务审批人" 
            dataIndex="businessApproverNameList" 
            render={(text, record) => (
              <>
                {text.map((item, index) => (
                  <div key={index}>{item.name}({item.type})</div>
                ))}
              </>
            )}
          />
          <Column title="内控审批人" dataIndex="internalApproverName" />
          <Column title="审批时间" dataIndex="approvalTime" />
          <Column 
            title="操作"
            align="center"
            width={130}
            render={record => (
              <>
                <Link to={cryptoParamsIntoUrl('/billManage/customerBill/detail', { id: record.id })} target="_blank">
                  查看
                </Link>
                {record.canConfirmStatus && (
                  <a onClick={() => handleConfirm(record)} style={{ marginLeft: 5 }}>客户确认</a>
                )}
                {record.canRepayment && (
                  <Link to={cryptoParamsIntoUrl('/billManage/customerBill/payback', { id: record.id })} style={{ marginLeft: 5 }}>
                    还款
                  </Link>
                )}
                {record.canInvoice && (
                  <a 
                    onClick={() => handleInvoice(record)}
                    style={{ marginLeft: 5 }}
                    target="_blank"
                  >{record.invoiceButton}</a>
                )}
              </>
            )}
          />
        </Table>
      </div>
      <Drawer
        title="客户确认"
        width={600}
        onClose={() => setConfirmVisible(false)}
        visible={confirmVisible}
        destroyOnClose={true}
      >
        <CustomerConfirm 
          data={confirmData} 
          setVisible={setConfirmVisible} 
          getList={getList}
        />
      </Drawer>
    </Spin>
  </>
}

export default Form.create()(Main)
